import { Company } from "../gateway/Company/Company";

/**
 * Cancela pedidos de atualização do Domínio que ficaram pendentes.
 *
 * Sem `companyIds`, cancela a carteira inteira — por isso a lista vazia é tratada como "nenhum
 * filtro" só quando o chamador não passou nada: um array vazio vindo de uma seleção sem itens não
 * pode virar "cancelar tudo".
 */
export class CancelDominioUpdateUsecase {
    constructor() {
        this.CompanyGateway = new Company();
    }

    async execute({ accountingId, companyIds, sources } = {}) {
        const payload = this.sanitizeInput({ companyIds, sources });
        if (Array.isArray(companyIds) && !payload.companyIds.length) {
            return { success: true, cancelledCount: 0 };
        }

        try {
            return await this.CompanyGateway.cancelDominioUpdate({
                accountingId,
                companyIds: payload.companyIds.length
                    ? payload.companyIds
                    : undefined,
                sources: payload.sources.length ? payload.sources : undefined
            });
        } catch (error) {
            throw new Error(
                error?.message || "Não foi possível cancelar a atualização"
            );
        }
    }

    sanitizeInput({ companyIds = [], sources = [] } = {}) {
        const clean = (list) =>
            (Array.isArray(list) ? list : [])
                .map((item) => String(item || "").trim())
                .filter(Boolean);
        return { companyIds: clean(companyIds), sources: clean(sources) };
    }
}
